export default __webpack_public_path__ + "static/media/kadra_filip.3645f079.jpeg";